import type { BaseOrder } from '#domain/BaseOrder.ts';
import type { Material } from '#domain/Material.ts';
import type { Stop } from '#domain/Stop.ts';

export type TransportOrder = BaseOrder & {
    type?: 'transport';
    loadingStop: Stop;
    unloadingStop: Stop;
    loadingComment?: string;
    unloadingComment?: string;
    materials?: Material[];
};

export const getTransportOrderIcon = (): string => 'icon-truck';
